import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class ErrorService {

    private sErrorMessage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private errorMessage$: Observable<string>;

    constructor() {
        this.errorMessage$ = this.sErrorMessage.asObservable();
    }

    public get errorMessage(): Observable<string> {
        return this.errorMessage$;
    }

    public setErrorMessage(value: string) {
        this.sErrorMessage.next(value);
    }

    public getErrorMessage(): string {
        return this.sErrorMessage.value || null;
    }

}